import React from 'react';
import { CTAButton, CHECKOUT_URL, PRICE_SHORT, Section } from './Shared';
import { DnaHelix, TreeOfLife } from './BioDecor';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-66" data-mp="10ffkb8q6wbpx">
      <div className="relative overflow-hidden rounded-3xl border border-brand-greenSoft/40 bg-brand-sageMist/50 p-6 text-center md:p-12" data-id="element-67" data-mp="vlkzu32rfsps">
        <DnaHelix className="pointer-events-none absolute -left-4 -top-6 h-40 w-20 text-brand-blueSoft/30" data-id="element-68" data-mp="qn016835ph3g" />
        <TreeOfLife className="pointer-events-none absolute -bottom-8 -right-4 h-48 w-28 text-brand-greenSoft/25" data-id="element-69" data-mp="mjlkdf7e8woy" />
        <div className="relative" data-id="element-70" data-mp="cnijecoa343l">
          <h2 className="mb-6 font-display text-3xl font-bold leading-tight text-brand-blue md:text-4xl" data-id="element-71" data-mp="cmpbh8dl28jv">
            Tu próxima sesión puede ser diferente.
          </h2>
          <div className="mx-auto mb-10 max-w-2xl space-y-4 text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-72" data-mp="2719pj27ef5ua">
            <p data-id="element-73" data-mp="2226w6f0s6o25">Hay dos caminos.</p>
            <p data-id="element-74" data-mp="22386gh9z36it">
              <strong className="text-brand-blue" data-id="element-75" data-mp="220cb90pievy2">Uno</strong>: seguir acumulando apuntes, documentos y herramientas
              por separado… y continuar preguntándote durante algunas sesiones: “¿Dónde tenía eso?”, “¿Qué le
              pregunto ahora?”, “¿Cómo cierro esto?”.
            </p>
            <p className="font-semibold text-brand-greenMid" data-id="element-76" data-mp="2v6furrqh4dac">
              Otro: decidir que desde hoy tu conocimiento empieza a tener una estructura que te acompañe.
            </p>
            <p className="font-serif text-lg italic text-brand-goldDark md:text-xl" data-id="element-77" data-mp="3ntim9zwqfnr3">
              No necesitas abandonar lo que ya aprendiste. Necesitas organizarlo.
              <br data-id="element-78" data-mp="3e3z28qxa9nun" />
              El conocimiento ya lo tienes. Ahora ten el sistema al lado.
            </p>
          </div>

          <div className="mx-auto max-w-md rounded-2xl border-2 border-brand-gold/60 bg-white p-6 shadow-[0_10px_30px_rgba(8,32,60,.14)]" data-id="element-79" data-mp="3j0plto8ar1kt">
            <span className="relative -top-9 inline-block rounded-full bg-brand-blue px-3 py-1 text-xs font-bold text-brand-goldLight" data-id="element-80" data-mp="fd7428wyz5uq">
              ⭐ MÁS ELEGIDO
            </span>
            <h3 className="-mt-4 font-serif text-xl font-bold text-brand-blue" data-id="element-81" data-mp="p734o3ifp4wy">
              🏆 KIT MAESTRO DE BIODESCODIFICACIÓN™
            </h3>
            <p className="my-2 text-4xl font-bold text-brand-greenMid" data-id="element-82" data-mp="g7pu17ikqaan">🔥 {PRICE_SHORT}</p>
            <p className="mb-5 text-sm leading-relaxed text-brand-muted" data-id="element-83" data-mp="ba7kpg0n9t24">
              3 Tomos + 5 Bonus · Más de 150 páginas. Protocolos, exploración estructurada, prácticas de integración
              y documentación profesional en un solo lugar.
            </p>
            <CTAButton href={CHECKOUT_URL} variant="gold" fullWidth className="text-sm md:text-base" data-id="element-84" data-mp="1hs5urkn9klg">
              🏆 → QUIERO ACCEDER AHORA
            </CTAButton>
            <p className="mt-4 text-[11px] text-brand-muted" data-id="element-85" data-mp="3opvto2ueg26c">
              📥 Acceso inmediato · 💱 El valor se adapta a tu moneda local · 📱 100% digital · 🛡️ Garantía 7 días ·
              🔐 Pago seguro
            </p>
          </div>
        </div>
      </div>
    </Section>;
}